<template>
  <div class="idx-bg edu-bg">
    <!--院校图片待用-->
    <div class="college-bg prelative" :style="{'display':isDetail?'block':'none'}">
      <div class="lbg pabsolute"></div>
      <div class="htmldiv fs0">
        <div class="txt fs14 twhite dinline-block vtop">
          <div class="igs mb10 mt20">
            <img src="../../assets/images/list_02.png" alt="" class="src">
          </div>
          <div class="lh20">官网：http://jxjy.zjgsu.edu.cn</div>
          <div class="lh20">电话：0571-88072967</div>
          <div class="lh20">地址：杭州市教工路198号</div>
        </div>
        <div class="rbg dinline-block vtop"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  props: [
    'isDetail'
  ]
}
</script>

<style scoped>
  .idx-bg{height: 265px;}
  .edu-bg{background: #e7e8ea url(../../assets/images/list_01_01.jpg) no-repeat center top;}
  .college-bg{height: 220px;background: #40913e url(../../assets/images/index_03_04.jpg) no-repeat top right;}
  .college-bg .lbg{z-index: 2;left: 0;width: calc(50% - 640px);height: 100%;background: #40913e;}
  .college-bg .rbg{width: 305px;height: 220px;background: url(../../assets/images/list_03_01.png) no-repeat left bottom;}
  .college-bg .igs img{height: 80px; }
  .college-bg .txt{z-index: 3;padding-left: 30px;height: 220px;background: #40913e;}
</style>



// WEBPACK FOOTER //
// src/components/main/banner.vue